<template>
  <form :action="window.contextPath + '/search'" method="get" class="input-group" :class="{'transitioning': transitioning || active, 'active': active}">
    <input name="q"
           type="text"
           v-model="query"
           @focus="focus"
           @blur="blur"
           class="form-control"
           :placeholder="bundle.id_10906"/>
    <button type="submit" class="input-group-text">
      <i class="fa-light fa-search"></i>
    </button>
  </form>
</template>

<script>
import Vue from "vue";

export default {
  name: "global-search-input",
  data: function () {
    return {
      focused: false,
      transitioning: false,
      activated: false,
      activating: null,
      deactivating: null,
      query: "",
      bundle: {
        id_10906: "Enter keywords...",
      },
    }
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
    if (window.location.pathname === `${window.contextPath}/search`) {
      const urlParams = new URLSearchParams(window.location.search);
      const q = urlParams.get("q");
      if (q) {
        this.query = q;
      }
    }
  },
  computed: {
    active: function () {
      return this.activated || this.query.length;
    }
  },
  watch: {
    focused: function (newValue) {
      if (newValue) {
        this.activate();
      } else {
        this.deactivate();
      }
    }
  },
  methods: {
    focus: function () {
      this.focused = true;
    },
    blur: function () {
      this.focused = false;
    },
    reset: function () {
      if (this.activating) {
        clearTimeout(this.activating);
        this.activating = null;
      }
      if (this.deactivating) {
        clearTimeout(this.deactivating);
        this.deactivating = null;
      }
    },
    activate: function () {
      this.reset();
      this.transitioning = true;
      this.activating = setTimeout(() => {
        this.activated = true;
      }, 0);
    },
    deactivate: function () {
      this.reset();
      this.activated = false;
      this.deactivating = setTimeout(() => {
        this.transitioning = false;
      }, 100); // Matches the CSS transition
    }
  }
}
</script>

<style scoped lang="less">

.input-group {
  overflow: hidden;
  position: relative;

  .form-control {
    border-radius: 50rem !important;
    background-color: var(--nm-beige);
    border-color: var(--nm-beige);
    box-shadow: none;

    &::placeholder {
      color: var(--nm-grey-60) !important;
      transition: .1s;
    }
  }

  .input-group-text {
    border-radius: 0 50rem 50rem 0 !important;
    background-color: var(--nm-beige);
    border-color: var(--nm-beige);
    display: none;

    i {
      opacity: 0;
      transition: all .1s ease;
    }
  }

  &.transitioning {
    .form-control {
      border-radius: 50rem 0 0 50rem !important;
    }

    .input-group-text {
      display: flex;

      i {
        opacity: 0;
      }
    }
  }

  &.active {
    .form-control {
      &::placeholder {
        color: var(--nm-grey-20) !important;
      }
    }

    .input-group-text {
      i {
        opacity: 1;
      }
    }
  }
}
</style>